export const brandInitialValues = (entity = {}) => {
    return ({
        name: entity ? entity?.name : "",
        description: entity ? entity?.description : "",
    });
};
